import { array, boolean, mixed, number, object, string } from 'yup';

export const filterFormSchema = object({
  filters: array()
    .of(
      object({
        isGroup: boolean().default(false),
        mode: string()
          .oneOf(['AND', 'OR'])
          .when('isGroup', {
            is: true,
            then: (schema) => schema.required('This field is required'),
            otherwise: (schema) => schema.default('AND'),
          }),
        rules: array()
          .of(
            object({
              field: string().required('This field is required'),
              mode: string().when('type', ([type], schema) => {
                if (type === 'date' || type === 'select') return schema.nullable();
                return schema.required('This field is required');
              }),
              type: string(),
              value: string().when(['mode', 'type'], ([mode, type], schema) => {
                if (mode === 'equals:null' || mode === 'not:null') return mixed().nullable();

                if (type === 'number')
                  return number()
                    .required('This field is required')
                    .label('Value')
                    .typeError('Must be a number');
                if (type === 'date')
                  return object({
                    gte: string().test({
                      name: 'min-date',
                      message: 'Date must be after 1900',
                      test: function (value) {
                        if (!value) return true;
                        const date = new Date(value);
                        return (
                          date.getFullYear() >= 1900 &&
                          date <= new Date(new Date().setDate(new Date().getDate() + 1))
                        );
                      },
                    }),
                    lte: string().test({
                      name: 'max-date',
                      message: 'Date must not be in the future',
                      test: function (value) {
                        if (!value) return true;
                        const date = new Date(value);
                        return (
                          date.getFullYear() >= 1900 &&
                          date <= new Date(new Date().setDate(new Date().getDate() + 1))
                        );
                      },
                    }),
                  })
                    .test({
                      name: 'date-range-validation',
                      message: 'To date must be greater than or equal to From date',
                      test: function (value) {
                        if (!value || !value.gte || !value.lte) return true;
                        const fromDate = new Date(value.gte);
                        const toDate = new Date(value.lte);
                        return fromDate <= toDate;
                      },
                    })
                    .label('Value');
                if (type === 'string')
                  return string()
                    .required('This field is required')
                    .trim()
                    .min(1, 'This field is required')
                    .label('Value')
                    .typeError('Must be a string');
                if (type === 'select')
                  return string()
                    .required('This field is required')
                    .label('Value')
                    .typeError('Must be a string');

                return schema;
              }),
            }),
          )
          .default([]),
      }),
    )
    .default([
      {
        isGroup: false,
        rules: [
          {
            field: '',
            mode: '',
            value: '',
            type: '',
          },
        ],
      },
    ]),
});
